<div class="bmc-bot-configuration">
    <div class="bmc-bot-configuration__content">
        <div class="bmc-bot-configuration__title bz-flex bz-flex--spaced">
            <h4 class="bz-font-weight--semibold">{{ 'RPA_BOTS.RPA_CONFIGURATION' | translate }}</h4>
        </div>
        <h5 class="bz-space--stack-m">{{ 'RPA_BOTS.RPA_CONFIGURATION_DESCRIPTION' | translate }}</h5>
        <form #botConfigForm="ngForm">
            <div class="bz-flex bz-space--stack-m">
                <bzg-input name="displayName" class="bmc-bot-configuration__input  bz-space--inline-m" [required]="true"
                    [(ngModel)]="botDetail.displayName">
                    {{ ('RPA_BOTS.DISPLAY_NAME') | translate }}
                    <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                </bzg-input>
            </div>
            <h5 class="bz-font-weight--semibold bz-space--stack-xs">{{ 'RPA_BOTS.CONNECTION_TYPE' | translate }}</h5>
            <div class="uipath-configuration--togglebutton bz-space-inset-squish-xs">
                <bzg-button-toggle-group (change)="changeConnectionTypeDev($event)" [value]="botDetail.connectionType">
                    <bzg-button-toggle [value]="uipathConnectionType.onPremise">
                        {{'RPA_BOTS.ON_PREMISE' | translate}}
                    </bzg-button-toggle>
                    <bzg-button-toggle [value]="uipathConnectionType.cloud">
                        {{'RPA_BOTS.CLOUD' | translate}}
                    </bzg-button-toggle>
                </bzg-button-toggle-group>
            </div>
            <div class="bz-space--stack-s"></div>
            <div class="bz-space--inset-squish-s bz-space--stack-m connection-info"
                *ngIf="botDetail.connectionType == uipathConnectionType.onPremise || !botDetail.connectionType">
                <div class="bz-flex bz-space--stack-m">
                    <bzg-input name="name" class="bmc-bot-configuration__input  bz-space--inline-m" [required]="true"
                        [(ngModel)]="botDetail.tenancyName">
                        {{ ('RPA_BOTS.TENANT_NAME') | translate }}
                        <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                    </bzg-input>
                    <bzg-input name="email" class="bmc-bot-configuration__input" [required]="true"
                        [(ngModel)]="botDetail.userNameOrEmailAddress">
                        {{ 'RPA_BOTS.USERNAME_EMAIL' | translate }}
                        <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                    </bzg-input>
                </div>
                <div class="bz-flex bz-space--stack-m">
                    <bzg-password name="password" class="bmc-bot-configuration__input bz-space--inline-m"
                        [required]="true" [(ngModel)]="botDetail.password">
                        {{ 'GLOBAL.PASSWORD' | translate }}
                        <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                    </bzg-password>
                    <bzg-input name="url" class="bmc-bot-configuration__input" [required]="true"
                        [(ngModel)]="botDetail.server" [pattern]="URL_REGEXP">
                        {{('RPA_BOTS.ORCHESTRATOR_URL') | translate }}
                        <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                        <bzg-pattern-error>{{'GLOBAL.INVALID_URL' | translate}}</bzg-pattern-error>
                    </bzg-input>
                </div>
            </div>
            <div *ngIf="botDetail.connectionType == uipathConnectionType.cloud">
                <div class="bz-space--inline-s bz-space--stack-xs">
                    <bzg-radio-group name="SelectAuthType" (change)="changeAuthTypeDev($event)"
                        class="uipath-configuration--radiobutton" [(ngModel)]="botDetail.authType">
                        <bzg-radio-button [value]="authType.apiAccess">
                            <span class="lbl-biz">{{'RPA_BOTS.APIACCESS'|translate}}</span>
                        </bzg-radio-button>
                        <bzg-radio-button [value]="authType.clientCredentials">
                            <span class="lbl-biz">{{'RPA_BOTS.CLIENTCREDENCTIALS'|translate}}</span>
                        </bzg-radio-button>
                    </bzg-radio-group>
                </div>
                <div class="bz-space--inset-squish-s bz-space--stack-m connection-info">

                    <div *ngIf="botDetail.authType == authType.apiAccess">
                        <div class="bz-flex bz-space--stack-m">
                            <bzg-password name="name" class="bmc-bot-configuration__input  bz-space--inline-m"
                                [required]="true" [(ngModel)]="botDetail.userKey">
                                {{ ('RPA_BOTS.USERKEY') | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-password>
                            <bzg-input name="email" class="bmc-bot-configuration__input" [required]="true"
                                [(ngModel)]="botDetail.accountLogicalName">
                                {{ 'RPA_BOTS.ORGANIZATIONID' | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-input>
                        </div>
                        <div class="bz-flex bz-space--stack-m">
                            <bzg-input name="password" class="bmc-bot-configuration__input bz-space--inline-m"
                                [required]="true" [(ngModel)]="botDetail.tenantLogicalName">
                                {{ 'RPA_BOTS.TENANT_NAME' | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-input>
                            <bzg-password name="url" class="bmc-bot-configuration__input" [required]="true"
                                [(ngModel)]="botDetail.clientId">
                                {{('RPA_BOTS.CLIENTID') | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-password>
                        </div>
                    </div>
                    <div *ngIf="botDetail.authType == authType.clientCredentials">
                        <div class="bz-flex bz-space--stack-m">
                            <bzg-input name="grantType" class="bmc-bot-configuration__input  bz-space--inline-m"
                                [(ngModel)]="botDetail.grantType" disabled>
                                {{ ('RPA_BOTS.CLIENTCREDENCTIALS') | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-input>
                            <bzg-input name="accountLogicalName1" class="bmc-bot-configuration__input" [required]="true"
                                [(ngModel)]="botDetail.accountLogicalName">
                                {{ 'RPA_BOTS.ORGANIZATIONID' | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-input>
                        </div>
                        <div class="bz-flex bz-space--stack-m">
                            <bzg-input name="tenantLogicalName1" class="bmc-bot-configuration__input bz-space--inline-m"
                                [required]="true" [(ngModel)]="botDetail.tenantLogicalName">
                                {{ 'RPA_BOTS.TENANT_NAME' | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-input>
                            <bzg-password name="clientId1" class="bmc-bot-configuration__input" [required]="true"
                                [(ngModel)]="botDetail.clientId">
                                {{('RPA_BOTS.CLIENTID') | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-password>
                        </div>
                        <div class="bz-flex bz-space--stack-m">
                            <bzg-password name="clientSecret1" class="bmc-bot-configuration__input bz-space--inline-m"
                                [required]="true" [(ngModel)]="botDetail.clientSecret">
                                {{('RPA_BOTS.CLIENTSECRET') | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-password>
                            <bzg-input name="authUrl1" class="bmc-bot-configuration__input" disabled
                                [(ngModel)]="botDetail.authUrl" value="constAuthClientCredentials.authUrl">
                                {{ 'RPA_BOTS.AUTHRURL' | translate }}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                            </bzg-input>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="bz-flex bz-flex--end bz-space--stack-l">
            <bzg-button-secondary class="bz-space--inline-m" (click)="onClearAll()">{{ 'RPA_BOTS.CLEAR_ALL' | translate
                }}
            </bzg-button-secondary>
            <bzg-button-primary (click)="onTestConnection()">{{ 'RPA_BOTS.TEST_CONNECTION' | translate }}
            </bzg-button-primary>
        </div>

        <bot-processes [title]="'RPA_BOTS.UIPATH_PROCESSES'"
            [botProcesses]="!botDetail.processes ? botDetail.queues : botDetail.processes">
        </bot-processes>
        <div class="bmc-bot-dashboard" *ngIf="botDetail.processes && botDetail.processes.length > 0">
            <div class="bmc-bot-configuration__title bz-flex bz-flex--spaced">
                <h4 class="bz-font-weight--semibold">{{ 'RPA_BOTS.RPA_DASHBOARD' | translate }}</h4>
            </div>
            <div class="bz-flex bz-flex--end bz-space--stack-l">
                <bzg-button-secondary class="bz-space--inline-m" [disabled]="!isValid()" (click)="showCharts()">{{
                    'RPA_BOTS.CHARTS' | translate
                    }}
                </bzg-button-secondary>
                <bzg-button-secondary class="bz-space--inline-m" [disabled]="!isValid()" style="margin-right: 0;"
                    (click)="showRetries()">
                    {{ 'RPA_BOTS.RETRIES' | translate }}
                </bzg-button-secondary>
            </div>
        </div>
    </div>
</div>
<div class="save-class">
    <bzg-button-primary [disabled]="!isValid()" (click)="onSave()">{{ 'GLOBAL.SAVE' | translate }}</bzg-button-primary>
</div>

<div *ngIf="chartsVisible" class="dashboard-tab">
    <bzg-button-icon class="close-button bz-font-weight--semibold" icon="icon-close-strong" size="l"
        (click)="closeCharts()"></bzg-button-icon>
    <biz-uipath-dashboard-wrapper [uiPathOriginalConnection]="botDetail"></biz-uipath-dashboard-wrapper>
</div>
<div *ngIf="retriesVisible" class="dashboard-tab">
    <bzg-button-icon class="close-button bz-font-weight--semibold" icon="icon-close-strong" size="l"
        (click)="closeRetries()"></bzg-button-icon>
    <biz-uipath-retries-wrapper [uiPathOriginalConnection]="botDetail"></biz-uipath-retries-wrapper>
</div>